import { setLoaderAvailable, resetLoaderAvailable } from "../../../redux/slices/loaderController";
import { AppDispatch } from "../../../redux/store";
import { getStudentDebt } from "../../../services/finance/studentDebt";
import { getStudentById } from "../../../services/school/student/getStudentByCode";
import { getUserById } from "../../../services/user/getUsers";
import { TokenResponseType } from "../../../types/TokenResponse";
import { receiptPayload } from "./receiptPayload";

export interface SchoolBankConfig {
  bankEntity: string;
  bankName: string;
}
export type ExportDocumentFn = (
  payload: unknown,
  documentType: "RECEIPT"
) => Promise<void>;

export  const printReceipt = async (data:{
    studentDebtId: string;
    schoolBankConfigsData: SchoolBankConfig[];
    IES: unknown;
    logoBase64?: string | undefined;
    dispatch: AppDispatch;
    exportDocument: ExportDocumentFn;
    loggedUserData : TokenResponseType;
}) => {
    const {studentDebtId, IES, logoBase64, exportDocument,schoolBankConfigsData, dispatch, loggedUserData} = data;
     dispatch(setLoaderAvailable(true)); 
    const response = await getStudentDebt({
    PageSize: 1,
    PageNumber: 1,
    Id: studentDebtId,
  });
    const studentDebt = response?.items[0];
    if (!studentDebt) {
      dispatch(setLoaderAvailable(false));
      return;
    }

    const paymentRef = studentDebt.paymentReferences?.[0];
    if (paymentRef) {
    const bank = schoolBankConfigsData?.find(
      b => b.bankEntity === paymentRef.entity
    );
    studentDebt.bankName = bank?.bankName;
    studentDebt.entityCode = paymentRef.entity;
    studentDebt.referenceCode = paymentRef.referenceCode;
  }

    const student = await getStudentById(studentDebt.idStudent);
    const user = await getUserById(student.idUser);
    const payload = receiptPayload({
        studentDebt,
        student,
        user,
        loggedUserData,
        IES,
        logoBase64,
    });
    await exportDocument(payload, "RECEIPT");

    dispatch(resetLoaderAvailable());
};
